"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _shared = require("@widget-editor/shared");

var _utils = require("./utils");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ColumnSelections = function ColumnSelections(_ref) {
  var compact = _ref.compact,
      columns = _ref.columns,
      configuration = _ref.configuration,
      patchConfiguration = _ref.patchConfiguration;

  var _configuration$catego, _configuration$value;

  var chartType = configuration.chartType,
      xAxisTitle = configuration.xAxisTitle,
      yAxisTitle = configuration.yAxisTitle;
  var categoryName = (configuration === null || configuration === void 0 ? void 0 : (_configuration$catego = configuration.category) === null || _configuration$catego === void 0 ? void 0 : _configuration$catego.name) || null;
  var valueName = (configuration === null || configuration === void 0 ? void 0 : (_configuration$value = configuration.value) === null || _configuration$value === void 0 ? void 0 : _configuration$value.name) || null;
  var selectedValue = valueName ? columns.find(function (col) {
    return col.identifier === valueName;
  }) : null;
  var selectedCategory = categoryName ? columns.find(function (col) {
    return col.identifier === categoryName;
  }) : null;

  var _ref2 = (0, _react.useState)(xAxisTitle),
      _ref3 = _slicedToArray(_ref2, 2),
      xTitle = _ref3[0],
      setXTitle = _ref3[1];

  var _ref4 = (0, _react.useState)(yAxisTitle),
      _ref5 = _slicedToArray(_ref4, 2),
      yTitle = _ref5[0],
      setYTitle = _ref5[1];

  var _ref6 = (0, _react.useState)({
    chartValue: selectedValue,
    chartCategory: selectedCategory
  }),
      _ref7 = _slicedToArray(_ref6, 2),
      chartOptions = _ref7[0],
      setChartOptions = _ref7[1];

  (0, _react.useEffect)(function () {
    if (xAxisTitle !== xTitle) {
      setXTitle(xAxisTitle);
    }

    if (yAxisTitle !== yTitle) {
      setYTitle(yAxisTitle);
    }
  }, [xAxisTitle, yAxisTitle, xTitle, yTitle]);
  (0, _react.useEffect)(function () {
    var _configuration$value2, _configuration$catego2;

    var valueIdentifier = configuration === null || configuration === void 0 ? void 0 : (_configuration$value2 = configuration.value) === null || _configuration$value2 === void 0 ? void 0 : _configuration$value2.name;
    var categoryIdentifier = configuration === null || configuration === void 0 ? void 0 : (_configuration$catego2 = configuration.category) === null || _configuration$catego2 === void 0 ? void 0 : _configuration$catego2.name;
    var selectedValue = valueIdentifier ? _toConsumableArray(columns).find(function (col) {
      return col.name === valueIdentifier;
    }) : null;
    var selectedCategory = categoryIdentifier ? _toConsumableArray(columns).find(function (col) {
      return col.name === categoryIdentifier;
    }) : null;
    setChartOptions({
      chartValue: selectedValue,
      chartCategory: selectedCategory
    });
  }, [configuration, columns]);

  var handleChangeCategory = function handleChangeCategory(selectedOption) {
    patchConfiguration({
      category: _objectSpread({}, configuration.category, {}, selectedOption)
    });
  };

  var handleChangeValue = function handleChangeValue(selectedOption) {
    patchConfiguration({
      value: _objectSpread({}, configuration.value, {}, selectedOption)
    });
  };

  var reverse = ["bar", "line", "scatter", "stacked-bar"].indexOf(chartType) > -1;
  var isPieOrDonut = chartType === "pie" || chartType === "donut";
  return _react["default"].createElement(_react.Fragment, null, isPieOrDonut && _react["default"].createElement(_shared.Select, {
    align: "horizontal",
    menuPlacement: "top",
    placeholder: "Value",
    compact: compact,
    value: chartOptions.chartValue,
    onChange: handleChangeValue,
    getOptionLabel: function getOptionLabel(option) {
      return (0, _utils.resolveLabel)(yTitle, option);
    },
    getOptionValue: function getOptionValue(option) {
      return option.identifier;
    },
    options: columns,
    configuration: configuration,
    isCustom: true,
    isPopup: true
  }), !isPieOrDonut && _react["default"].createElement(_react.Fragment, null, !reverse && _react["default"].createElement(_shared.Select, {
    align: "vertical",
    menuPlacement: "top",
    placeholder: "Category",
    value: chartOptions.chartCategory,
    onChange: handleChangeCategory,
    getOptionLabel: function getOptionLabel(option) {
      return (0, _utils.resolveLabel)(xTitle, option);
    },
    getOptionValue: function getOptionValue(option) {
      return option.identifier;
    },
    options: columns,
    configuration: configuration,
    isCustom: true,
    isPopup: true
  }), reverse && _react["default"].createElement(_shared.Select, {
    align: "vertical",
    menuPlacement: "top",
    placeholder: "Value",
    value: chartOptions.chartValue,
    onChange: handleChangeValue,
    getOptionLabel: function getOptionLabel(option) {
      return (0, _utils.resolveLabel)(yTitle, option);
    },
    getOptionValue: function getOptionValue(option) {
      return option.identifier;
    },
    options: columns,
    configuration: configuration,
    isCustom: true,
    isPopup: true
  }), !reverse && _react["default"].createElement(_shared.Select, {
    align: "horizontal",
    compact: compact,
    menuPlacement: "top",
    placeholder: "Value",
    value: chartOptions.chartValue,
    onChange: handleChangeValue,
    getOptionLabel: function getOptionLabel(option) {
      return (0, _utils.resolveLabel)(yTitle, option);
    },
    getOptionValue: function getOptionValue(option) {
      return option.identifier;
    },
    options: columns,
    configuration: configuration,
    isCustom: true,
    isPopup: true
  }), reverse && _react["default"].createElement(_shared.Select, {
    align: "horizontal",
    compact: compact,
    menuPlacement: "top",
    placeholder: "Category",
    value: chartOptions.chartCategory,
    onChange: handleChangeCategory,
    getOptionLabel: function getOptionLabel(option) {
      return (0, _utils.resolveLabel)(xTitle, option);
    },
    getOptionValue: function getOptionValue(option) {
      return option.identifier;
    },
    options: columns,
    configuration: configuration,
    isCustom: true,
    isPopup: true
  })));
};

var _default = ColumnSelections;
exports["default"] = _default;